import React from "react";

import Lamina19img1 from "../images/lamina19img1.png";
import Lamina19img2 from "../images/lamina19img2.png";
import Lamina19actividad from "../images/lamina19actividad.png";
import Lamina19texto from "../images/lamina19texto.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  green: {
    color: theme.palette.green.main,
    borderColor: theme.palette.green.main,
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
      marginLeft: 20,
    },
    "& li": {
      textAlign: "left",
    },
    "& img": {
      width: "100%",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
      "& p": {
        marginLeft: 0,
      },
    },
  },
}));

const Lamina19 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 19: En busca de la igualdad de oportunidades"
        meta={[
          {
            property: "og:title",
            content: "Lámina 19: En busca de la igualdad de oportunidades",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "En el Perú, algunas personas tienen mayores oportunidades que otras.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="19" color="green" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Title title="En busca de la igualdad de oportunidades" color="green" />
        <p>
          En el Perú, algunas personas tienen mayores oportunidades que otras.
          Eso se llama desigualdad social y es uno de los problemas que tenemos
          actualmente como país. La desigualdad social se puede notar en el
          acceso a servicios esenciales como agua potable, desagüe y energía
          eléctrica, así como a una educación y salud de calidad.
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="green" />
        <p>
          <strong>Observa las siguientes imágenes:</strong>
        </p>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <img src={Lamina19img2} alt="Actividad" />
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={8}>
            <img src={Lamina19img1} alt="Actividad" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="green" />
        <p>
          <strong>Lee y reflexiona sobre el caso de Olga.</strong>
        </p>
        <p>
          Olga proviene de una familia de pocos recursos económicos. Cuando
          terminó el colegio quiso estudiar para ser una profesional. Con el
          esfuerzo de su familia y trabajando en lo que podía mientras
          estudiaba, pudo alcanzar sus metas. Sin embargo, Olga concluyó sus
          estudios varios años después de otros compañeros y compañeras que
          tenían mejores condiciones, y las pocas horas de descanso y de sueño
          por momentos perjudicaron su salud mientras estudiaba.
        </p>
        <Grid
          container
          className={classes.root}
          alignItems="center"
          justify="flex-start"
        >
          <Grid item lg={7} md={7} sm={7} xs={12}>
            <img src={Lamina19actividad} alt="Actividad" />
          </Grid>
          <Grid item lg={4} md={4} sm={4} xs={12}>
            <p>
              <strong>
                Luego de reflexionar, conversa con tu familia sobre las
                siguientes preguntas:
              </strong>
            </p>
            <ul>
              <li>¿Por qué Olga pudo seguir una profesión?</li>
              <li>
                ¿Por qué Olga no pudo terminar la carrera en el mismo tiempo que
                sus compañeros?
              </li>
              <li>
                ¿Por qué es importante tener las mismas oportunidades de
                estudio?
              </li>
            </ul>
            <br></br>
            <p>
              <img src={Lamina19texto} alt="Actividad" />
            </p>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-19.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.green }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 19: En busca de la igualdad de oportunidades'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="Las distintas formas de ser peruano"
        anteriorEnlace="/lamina-1-18"
        siguiente="La equidad de género en el Perú"
        siguienteEnlace="/lamina-1-20"
      />
    </>
  );
};

export default Lamina19;
